/**
 * Класс для `ScrollArea`: возвращает внутреннему div вьюпорта Radix блочное поведение.
 *
 * По умолчанию Radix задаёт этому div `display: table` — из-за этого содержимое растягивается
 * по самой длинной строке, а не по ширине области: сокращение и перенос текста не срабатывают,
 * и на узком экране появляется горизонтальная прокрутка вместе с раздутой карточкой.
 */
export const SCROLL_AREA_VIEWPORT_BLOCK = '[&>[data-radix-scroll-area-viewport]>div]:!block';
